import './App.css';
// import "bootstrap/dist/css/bootstrap.min.css";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.min.css";
// import "./custom.css";
// import "./style.css";
// import "./responsive.css";
import "react-datepicker/dist/react-datepicker.css";
import Router from './router/NavRouter';
import { ToastContainer } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import React from 'react';
import Home from './pages/Home/Home';
import { ModalProvider } from './contexts/ModalContext';
import SEO from "./helper/SEO";
import { BaseUrl } from "./helper/BaseUrl";
import FaqContext from "./contexts/FaqContext";

function useSEOData(pathname) {
  const [seoData, setSeoData] = useState(undefined);

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/seo-by-url${pathname}`);
        const result = await response.json();
        if (result.seo === false) {
          throw new Error(`API error: ${result.message}`);
        }
        setSeoData(result.seo || null);
      } catch (error) {
        setSeoData(null);
      }
    };

    fetchSeo();
  }, [pathname]);

  return seoData;
}

function useGlobalSEOData() {
  const [schemaData, setSchemaData] = useState(undefined);

  useEffect(() => {
    const fetchSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`);
        const result = await response.json();
        setSchemaData(result.schema || null);
      } catch (error) {
        setSchemaData(null);
      }
    };

    fetchSchema();
  }, []);

  return schemaData;
}

function App({ initialData, initialSeo, initialSchema, initialFaq }) {
  const location = useLocation();
  const seoData = useSEOData(location.pathname);
  const schemaData = useGlobalSEOData();
  const activeSchema = schemaData !== undefined ? schemaData : initialSchema;


  // source Url
  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);


  const NormalizeTrailingSlash = () => {
    useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  if (location.pathname === "/") {
    return (
      <div className="App">
        <NormalizeTrailingSlash />
        <SEO initialSeo={initialSeo} clientSeo={seoData} initialSchema={activeSchema} />
        <FaqContext.Provider value={initialFaq}>
          <Home />
        </FaqContext.Provider>
      </div>
    )
  }

  return (
    <div className="App">
      <NormalizeTrailingSlash />
      <SEO initialSeo={initialSeo} clientSeo={seoData} initialSchema={activeSchema} />
      <ModalProvider>
        <FaqContext.Provider value={initialFaq}>
          <Router initialData={initialData} initialFaq={initialFaq}/>
        </FaqContext.Provider>
      </ModalProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
